<template>
    <el-card class="profile-card" :body-style="{ padding: '32px 28px' }">
        <div class="profile-header">
            <div class="avatar-ring tech-avatar">
                <img src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=200&h=200&fit=crop" alt="avatar" class="avatar-img"/>
            </div>
            <h1 class="profile-name">苏七的博客</h1>
            <p class="profile-title">Java 后端开发者</p>
        </div>
        
        <div class="profile-info">
            <div class="info-item">
                <i class="el-icon-location-information"></i>
                <span>成都 · 泸州</span>
            </div>
        </div>
        
        <div class="profile-divider"></div>
        
        <div class="profile-social">
            <div class="social-btn" @click="showTool(qq)" :title="qq.title">
                <i class="iconfont icon-qq"></i>
            </div>
            <div class="social-btn" @click="showTool(CSDN)" :title="CSDN.title">
                <i class="iconfont icon-bilibili-fill"></i>
            </div>
        </div>
    </el-card>
</template>

<script>
    export default {
        name: 'Mine',
        data() {
            return {
                qq: {title: 'QQ', message: '1141793961'},
                CSDN: {
                    title: 'CSDN',
                    message: '<a target="_blank" href="https://blog.csdn.net/weixin_45974277">https://blog.csdn.net/weixin_45974277</a>'
                }
            }
        },
        methods: {
            showTool(tool) {
                this.$message({
                    duration: 1000,
                    showClose: true,
                    dangerouslyUseHTMLString: true,
                    message: '<strong>' + tool.message + '</strong>'
                });
            }
        }
    }
</script>

<style scoped>
    /* 个人资料卡片 - 轻奢风格 */
    .profile-card :deep(.el-card__body) {
        padding: 32px 28px !important;
    }

    .profile-header {
        text-align: center;
        margin-bottom: 24px;
    }

    /* 头像光环 - 赛博朋克科技风 */
    .avatar-ring {
        width: 72px;
        height: 72px;
        margin: 0 auto 16px;
        padding: 3px;
        background: linear-gradient(135deg, var(--accent-soft) 0%, var(--accent-warm) 100%);
        border-radius: 50%;
    }

    .avatar-ring.tech-avatar {
        background: linear-gradient(135deg, rgba(0, 255, 245, 0.6) 0%, rgba(236, 72, 153, 0.4) 100%);
        box-shadow: 0 0 20px rgba(0, 255, 245, 0.3), 0 0 40px rgba(0, 255, 245, 0.15);
    }

    .avatar-inner {
        width: 66px;
        height: 66px;
        background: var(--bg-card);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        font-weight: 600;
        color: var(--accent-warm);
    }

    .avatar-img {
        width: 66px;
        height: 66px;
        border-radius: 50%;
        object-fit: cover;
        display: block;
    }

    .profile-name {
        font-size: 20px;
        font-weight: 600;
        color: var(--text-primary);
        margin-bottom: 6px;
        letter-spacing: -0.3px;
    }

    .profile-title {
        font-size: 13px;
        color: var(--text-tertiary);
        font-weight: 400;
        margin: 0;
    }

    /* 信息区域 */
    .profile-info {
        margin-bottom: 20px;
    }

    .info-item {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-size: 13px;
        color: var(--text-secondary);
    }

    .info-item i {
        font-size: 14px;
        color: var(--accent-warm);
    }

    /* 分隔线 */
    .profile-divider {
        height: 1px;
        background: linear-gradient(90deg, transparent 0%, var(--border-light) 50%, transparent 100%);
        margin: 20px 0;
    }

    /* 社交按钮 */
    .profile-social {
        display: flex;
        justify-content: center;
        gap: 16px;
    }

    .social-btn {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--bg-secondary);
        border-radius: 50%;
        cursor: pointer;
        transition: all 0.25s ease;
    }

    .social-btn:hover {
        background: var(--accent-warm);
        transform: translateY(-2px);
    }

    .social-btn:hover i {
        color: white;
    }

    .social-btn i {
        font-size: 18px;
        color: var(--text-secondary);
        transition: color 0.25s ease;
    }
</style>
